<template>
  <div class="one-model-view">
    <span class="label">{{ i18n('titles', 'explain-model-' + model) }}</span>
    <div class="chart">
      <span class="title">{{ i18n('titles', 'breakdown') }}</span>
      <div class="plot-proxy-container">
        <PlotProxy :slotv="bdslot" />
      </div>
    </div>
    <div class="chart">
      <span class="title">
        {{ i18n('titles', 'ceteris-paribus-pre') }}
        <TitleDropdown :start="getGlobalParam('variable')" :values="availableParams.variable" :formating="(v) => i18n('variable', v)"
        :key="getGlobalParam('variable')" @update="setGlobalParam({ name: 'variable', value: $event })" />
        {{ i18n('titles', 'ceteris-paribus-post') }}
      </span>
      <div class="plot-proxy-container">
        <PlotProxy :slotv="cpslot" />
      </div>
    </div>
  </div>
</template>
<script>
import PlotProxy from '@/components/PlotProxy.vue'
import TitleDropdown from '@/components/TitleDropdown.vue'
import { mapGetters, mapMutations } from 'vuex'
import uuid from 'uuid/v4'

export default {
  name: 'OneModelView',
  props: {
    model: String
  },
  data () {
    return {
    }
  },
  computed: {
    bdslot () {
      return {
        name: 'Break Down',
        plotType: 'Breakdown',
        plotCategory: 'Observation Level',
        localParams: [{ model: this.model }],
        uuid: uuid(),
        archived: false,
        positionX: 0,
        positionY: 0,
        width: 0,
        height: 0,
        pageNumber: 0,
        /* eslint-disable-next-line */
        scope: 'model',
        customData: null
      }
    },
    cpslot () {
      return {
        name: 'Ceteris Paribus',
        plotType: 'CeterisParibus',
        plotCategory: 'Observation Level',
        localParams: [{ model: this.model }],
        uuid: uuid(),
        archived: false,
        positionX: 0,
        positionY: 0,
        width: 0,
        height: 0,
        pageNumber: 0,
        /* eslint-disable-next-line */
        scope: 'model',
        customData: null
      }
    },
    ...mapGetters(['getGlobalParam', 'availableParams', 'i18n'])
  },
  methods: {
    ...mapMutations(['setGlobalParam'])
  },
  components: {
    PlotProxy,
    TitleDropdown
  }
}
</script>
<style>
.one-model-view {
  background: #eee;
  margin: 30px;
  padding: 30px 30px 10px 30px;
  width: calc(100% - 120px);
  margin-bottom: 0;
}
.one-model-view > .label {
  display: block;
  font-size: 30px;
  color: #160e3b;
}
.one-model-view > .chart {
  position: relative;
  margin: 30px 30px 30px 0;
  display: inline-block;
  max-width: 600px;
  width: calc(50% - 54px);
  background: white;
  padding: 10px;
  border: 2px solid #ccc;
}
.one-model-view > .chart > .plot-proxy-container {
  height: 400px;
  position: relative;
}
.one-model-view > .chart > .title {
  display: block;
  font-size: 26px;
  color: #371ea3;
  margin-bottom: 10px;
  margin-left: 20px;
}
.one-model-view > .chart > .title > .variable-dropdown {
  cursor: pointer;
  border: 1px dashed #371ea3;
  padding: 2px;
}
.one-model-view > .chart > .title > .variable-dropdown > .caret {
  font-size: 16px;
  position: relative;
  bottom: 2px;
}
@media (max-width: 1200px) {
  .one-model-view {
    margin: 30px 30px;
    width: calc(100% - 120px);
  }
  .one-model-view > .chart {
    max-width: unset;
    margin: 30px 0;
    width: calc(100% - 20px);
    display: block;
  }
}
</style>
